import ProfileAPICall from "../service/ProfileAPICall";

class ProfileRepository {
    // Profile
    getProfileAccountInformation = async () => { // Not in used now
        return await new ProfileAPICall().getProfileAccountInformation();
    };

    fetchCarrierData = async (params) => {
        return await new ProfileAPICall().fetchCarrierData(params);
    };

    setContactData = async (params) => {
        return await new ProfileAPICall().setContactData(params);
    };

    getJobFunctionList = async () => {
        return await new ProfileAPICall().getJobFunctionListData();
    };

    getHeaderAccountList = async () => {
        return await new ProfileAPICall().getHeaderAccountList();
    };

    setAccountAddressDefault = async (data) => {
        return await new ProfileAPICall().setAccountAddressDefault(data);
    };

    setAccountLinkData = async (params) => {
        return await new ProfileAPICall().setAccountLinkData(params);
    };

    addProfileAddress = async (params) => {
        return await new ProfileAPICall().addProfileAddress(params);
    };
    validateProfileAddress = async (params) => {
        return await new ProfileAPICall().validateProfileAddress(params);
    };
    editProfileInvoiceAddress = async (params) => {
        return await new ProfileAPICall().editProfileInvoiceAddress(params);
    };

    getCountryList = async () => {
        return await new ProfileAPICall().getCountryList();
    };

    getStateList = async (countryCode) => {
        return await new ProfileAPICall().getStateList({ countryCode });
    };

    checkValidAccount = async (params) => {
        return await new ProfileAPICall().checkValidAccount(params);
    };

    setAccountLinkData = async (params) => {
        return await new ProfileAPICall().setAccountLinkData(params);
    };

}

export default ProfileRepository;